export default __webpack_public_path__ + "static/media/p4.e5cdda14.jpg";